import { createContext, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useIsMobile, useIsTablet } from './UseMediaQuery'

const SidebarContext = createContext(null)
// const ToggleSidebarContext = createContext(null);

export const SidebarProvider = ({ children }) => {
	const isMobile = useIsMobile()
	const isTablet = useIsTablet()
	const location = useLocation()

	const overlayStyle = isTablet || isMobile

	const [open, setOpen] = useState(false)

	function toggleSidebar() {
		setOpen(!open)
	}

	useEffect(() => {
		setOpen(!overlayStyle)
	}, [overlayStyle])

	// close sidebar when the page changes on mobile
	useEffect(() => {
		if (overlayStyle) {
			setOpen(false)
		}
		if (location.pathname.includes('/confirmation')) {
			setOpen(false)
		}
	}, [location.pathname])

	return (
		// <ToggleSidebarContext.Provider value={setIsOpen}>
		<SidebarContext.Provider value={{ open, toggleSidebar }}>
			{children}
		</SidebarContext.Provider>
		// </ToggleSidebarContext.Provider>
	)
}

export const useSidebar = () => {
	const context = useContext(SidebarContext)
	if (context == null) throw new Error('useTheme must be used within ThemeProvider')
	return context
}

// export const useToggleSidebar = () => {
//     const context = useContext(ToggleSidebarContext)
//     if (context == null) throw new Error("useTheme must be used within ThemeProvider");
//    return context;
// }
